import Marquee from "react-fast-marquee";

const items = [
  "AI CONSULTING",
  "EXTENSIVE HARDWARE + SOFTWARE EXPERIENCE",
  "DOZENS OF GOOGLE GLASS APPS DEVELOPED",
  "SMART GLASS DEVELOPMENT",
  "AI TRAINING",
  "IOT + ASSET TRACKING",
];

export default function CredibilityStrip() {
  return (
    <div
      data-testid="credibility-strip"
      className="border-y border-white/10 bg-[#070707] py-4 relative z-10"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-mono text-[11px] tracking-[0.3em] text-neutral-400 uppercase px-8">
              {item}
            </span>
            <span className="text-cyan text-xs animate-pulse-glow">//</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
